// removed by extract-text-webpack-plugin
module.exports = {"btn":"_2mtsvarZK24w8GKXvRg-HJ","logo":"_1BwMMmUPKwR0C3Z4nfG38B","container":"_1NIHFKRj5dljGhnLyvJRBd","title":"_3GhlfAumDfehCzpZgc5ZTA"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/VerifyAlert/styles.css
// module id = 2877
// module chunks = 0